import * as React from 'react';
import moment from 'moment';

interface Props extends React.ButtonHTMLAttributes<any> {
  onClick: () => void;
  disabledUntil: ReturnType<typeof Date.now>;
}

export class TimerButton extends React.Component<Props> {
  private timer?: ReturnType<typeof setInterval> | null;

  state = { delay: 0 };

  render() {
    const { children, disabledUntil, ...props } = this.props;
    const delay = this.getDelay();
    return (
      <button {...props} onClick={this.onClick} disabled={delay > 0}>
        {children}
        {delay > 0 ? `: ${this.formatTime(delay)}` : ''}
      </button>
    );
  }

  componentDidMount() {
    const { disabledUntil } = this.props;
    if (Date.now() < disabledUntil) {
      this.setupTimer();
    }
  }

  componentDidUpdate() {
    !this.timer && this.getDelay() > 0 && this.setupTimer();
  }

  componentWillUnmount() {
    this.closeTimer();
  }

  private tick() {
    const delay = this.getDelay();
    this.setState({ delay });
    delay <= 0 && this.closeTimer();
  }

  private setupTimer() {
    this.timer = setInterval(() => this.tick(), 500);
  }

  private closeTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  private getDelay() {
    return this.props.disabledUntil - Date.now();
  }

  private formatTime(time: number) {
    if (Math.floor(time / 1000) < 60) {
      return moment(time).format('ss');
    }
    return moment(time).format('mm:ss');
  }

  private onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.onClick();
  };
}

export default TimerButton;
